import Icon from '../components/Icon.vue'

Icon.register({
  'hand-lizard': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M384 480v-61.5c0-7.3-5-16.4-11.2-20.3l-111.7-70.8c-6.5-4.1-18-7.5-25.7-7.5h0-147.4c-13.3 0-24-10.7-24-24v-8c0-35.3 28.7-64 64-64h123.6c11.8 0 25-8.8 29.5-19.7l21.4-51.4c4.9-11.9-3.8-24.9-16.6-24.9h-230c-30.9 0-56-25.1-56-56v-16c0-13.3 10.7-24 24-24h333.5c14.6 0 32.8 10 40.6 22.4l163 258.1c8.2 13 14.8 35.9 14.8 51.3v0 116.2h-192z'
      }
    ]
  }
})
